function Grade({
  number,
  isSelected,
  onClick,
  variant = 'default',
  'data-testid': dataTestId,
}: {
  number: number
  isSelected: boolean
  onClick: () => void
  variant?: 'default' | 'improvement'
  'data-testid'?: string
}) {
  if (number === 0) return null

  return (
    <button
      className={`rounded-sm h-full w-full flex items-center justify-center text-sm py-1.5 select-none cursor-pointer ${
        isSelected
          ? variant === 'improvement'
            ? 'bg-purple-600 hover:bg-purple-600 text-white'
            : 'bg-purple-300 hover:bg-purple-300'
          : 'bg-warm-gray-200 hover:bg-warm-gray-300'
      }`}
      onClick={onClick}
      data-testid={dataTestId}
    >
      {number}
    </button>
  )
}

export default Grade
